import ajax from "@/lib/ajax";

// 查询手术提醒患者列表
export async function QueryPDSurgicalReminderList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDSurgicalReminder/QueryPDSurgicalReminderList`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdSurgicalReminder/index.ts